module.exports = require("./ln-AO.d.ts");